import type {PanelBooking} from "../types.ts";
import type {BookingTargetKind} from "../../../../../generated/enums.ts";

export interface BookingTarget {
    kind: BookingTargetKind;
    resource_id: string;
    line_item_id: string | null;
}

export function toBookingTargets(bookings: PanelBooking[]): BookingTarget[] {
    return bookings.flatMap((booking): BookingTarget[] => {
        if (booking.transactionId) {
            return [{kind: "TRANSACTION", resource_id: booking.transactionId, line_item_id: null}];
        }
        if (booking.billId && booking.billLineItemId) {
            return [{
                kind: "BILL_LINE_ITEM",
                resource_id: booking.billId,
                line_item_id: booking.billLineItemId,
            }];
        }
        return [];
    });
}
